export default __webpack_public_path__ + "static/media/bellamare1.66740f9a.jpg";